<div *ngIf="open && questionId" class="detail-modal-overlay" (click)="close()">
  <div class="detail-modal-dialog" (click)="$event.stopPropagation()">
    <div class="detail-modal-content">
      <div class="detail-modal-header">
        <h5 class="detail-modal-title">Question #{{ questionId }}</h5>
        <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
      </div>
      <div class="detail-modal-body">
        <app-question-detail-tabs
          [questionId]="questionId"
          [questionHtml]="questionHtml"
          [answersHtml]="answersHtml"
          [correctAnswer]="correctAnswer"
          [readOnlyQuestion]="true"
          [initialTab]="initialTab">
        </app-question-detail-tabs>
      </div>
    </div>
  </div>
</div>

